import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link } from "react-router-dom";
import "assets/theme/admin_list.css";
import { FaBuilding, FaPlus, FaEdit, FaTrash, FaCheck, FaTimes } from "react-icons/fa";

const DepartmentList = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await apiFetch("super_admin/list_department");
      setDepartments(res.departments || res);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const startEdit = (dept) => {
    setEditId(dept.department_id);
    setEditName(dept.department_name);
    setEditEmail(dept.email || "");
  };

  const cancelEdit = () => {
    setEditId(null);
    setEditName("");
    setEditEmail("");
  };

  const updateDepartment = async (id) => {
    if (!editName.trim()) {
      alert("Department name and email are required");
      return;
    }

    try {
      await apiFetch(`super_admin/edit_department/${id}`, {
        method: "PUT",
        body: JSON.stringify({ department_name: editName, email: editEmail }),
      });
      alert("Department updated successfully");
      cancelEdit();
      fetchDepartments();
    } catch (error) {
      alert(error.message);
    }
  };

  const deleteDepartment = async (id) => {
    if (!window.confirm("Are you sure you want to delete this department?")) return;

    try {
      await apiFetch(`super_admin/delete_department/${id}`, { method: "DELETE" });
      alert("Department deleted successfully");
      fetchDepartments();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="admin-page-container">
        {/* Header */}
        <div className="admin-header-card d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center">
            <div className="admin-header-icon">
              <FaBuilding />
            </div>
            <div>
              <h4 className="admin-header-title">विभाग व्यवस्थापन (Department Management)</h4>
              <p className="admin-header-subtitle mb-0">
                शासकीय व नागरी सेवा विभागांची यादी आणि ईमेल संपर्क व्यवस्थापित करा
              </p>
            </div>
          </div>
          <Link to="/departments" className="btn-admin-add">
            <FaPlus /> नवीन विभाग जोडा
          </Link>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-warning" role="status" />
              <p className="mt-2 text-muted fw-semibold">विभाग लोड होत आहेत...</p>
            </div>
          ) : departments.length === 0 ? (
            <div className="text-center py-5 text-muted">
              कोणताही विभाग आढळला नाही.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-admin-custom">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>विभाग नाव (Department Name)</th>
                    <th>ईमेल पत्ता (Email Contact)</th>
                    <th className="text-end">कृती (Actions)</th>
                  </tr>
                </thead>
                <tbody>
                  {departments.map((dept, index) => (
                    <tr key={dept.department_id}>
                      <td className="fw-bold text-secondary">{index + 1}</td>
                      <td>
                        {editId === dept.department_id ? (
                          <input
                            type="text"
                            className="form-control form-control-sm admin-select py-1 px-2"
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                          />
                        ) : (
                          <strong className="text-dark">{dept.department_name}</strong>
                        )}
                      </td>
                      <td>
                        {editId === dept.department_id ? (
                          <input
                            type="email"
                            className="form-control form-control-sm admin-select py-1 px-2"
                            value={editEmail}
                            onChange={(e) => setEditEmail(e.target.value)}
                          />
                        ) : (
                          <span className="text-secondary">{dept.email || "—"}</span>
                        )}
                      </td>
                      <td className="text-end">
                        {editId === dept.department_id ? (
                          <div className="admin-action-group justify-content-end">
                            <button
                              className="btn-action-icon btn-action-view"
                              onClick={() => updateDepartment(dept.department_id)}
                              title="जतन करा"
                            >
                              <FaCheck />
                            </button>
                            <button
                              className="btn-action-icon btn-action-delete"
                              onClick={cancelEdit}
                              title="रद्द करा"
                            >
                              <FaTimes />
                            </button>
                          </div>
                        ) : (
                          <div className="admin-action-group justify-content-end">
                            <button
                              className="btn-action-icon btn-action-edit"
                              onClick={() => startEdit(dept)}
                              title="संपादित करा"
                            >
                              <FaEdit />
                            </button>
                            <button
                              className="btn-action-icon btn-action-delete"
                              onClick={() => deleteDepartment(dept.department_id)}
                              title="हटवा"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default DepartmentList;
